'use strict';

module.exports = require('./dom-scroll-into-view');


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-scroll-into-view/lib/index.js
 ** module id = 42
 ** module chunks = 0
 **/